module.exports = __webpack_public_path__ + "static/media/est_0008_f.e3c12757.jpg";